package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.s

val FaqIconStyle = CssStyle {
    base { Modifier.transition(Transition.of("transform", 0.3.s)) }
}

val FaqRowHoverStyle = CssStyle {
    base { Modifier.transition(Transition.of("background-color", 0.2.s)) }
    hover { Modifier.backgroundColor(colorMode.toSitePalette().brand.primarySoft) }
}